"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.spacing = void 0;
exports.spacing = {
  '1': '0.1rem',
  '2': '0.2rem',
  '3': '0.3rem',
  '4': '0.4rem',
  '5': '0.5rem',
  '6': '0.6rem',
  '7': '0.7rem',
  '8': '0.8rem',
  '9': '0.9rem',
  '10': '1rem',
  '12': '1.2rem',
  '14': '1.4rem',
  '16': '1.6rem',
  '18': '1.8rem',
  '20': '2rem',
  '24': '2.4rem',
  '28': '2.8rem',
  '32': '3.2rem',
  '36': '3.6rem',
  '40': '4rem',
  '44': '4.4rem',
  '48': '4.8rem',
  '52': '5.2rem',
  '56': '5.6rem',
  '60': '6rem',
  '64': '6.4rem',
  '68': '6.8rem',
  '72': '7.2rem',
  '76': '7.6rem',
  '80': '8rem',
  '84': '8.4rem',
  '88': '8.8rem',
  '92': '9.2rem',
  '96': '9.6rem',
  '100': '10rem',
  '110': '11rem',
  '120': '12rem',
  '130': '13rem',
  '140': '14rem',
  '150': '15rem',
  '160': '16rem',
  '170': '17rem',
  '180': '18rem',
  '190': '19rem',
  '200': '20rem',
  '210': '21rem',
  '220': '22rem',
  '230': '23rem',
  '240': '24rem',
  '250': '25rem',
  '260': '26rem',
  '270': '27rem',
  '280': '28rem',
  '290': '29rem',
  '300': '30rem',
  '310': '31rem',
  '320': '32rem',
  '330': '33rem',
  '340': '34rem',
  '350': '35rem',
  '360': '36rem',
  '370': '37rem',
  '380': '38rem',
  '390': '39rem',
  '400': '40rem',
  '410': '41rem',
  '420': '42rem',
  '430': '43rem',
  '440': '44rem',
  '450': '45rem',
  '460': '46rem',
  '470': '47rem',
  '480': '48rem',
  '490': '49rem',
  '500': '50rem'
};
exports.size = __assign(__assign({}, exports.spacing), {
  '510': '51rem',
  '520': '52rem',
  '530': '53rem',
  '540': '54rem',
  '550': '55rem',
  '560': '56rem',
  '570': '57rem',
  '580': '58rem',
  '590': '59rem',
  '600': '60rem',
  '610': '61rem',
  '620': '62rem',
  '630': '63rem',
  '640': '64rem',
  '650': '65rem',
  '660': '66rem',
  '670': '67rem',
  '680': '68rem',
  '690': '69rem',
  '700': '70rem',
  '710': '71rem',
  '720': '72rem',
  '730': '73rem',
  '740': '74rem',
  '750': '75rem',
  '760': '76rem',
  '770': '77rem',
  '780': '78rem',
  '790': '79rem',
  '800': '80rem',
  '810': '81rem',
  '820': '82rem',
  '830': '83rem',
  '840': '84rem',
  '850': '85rem',
  '860': '86rem',
  '870': '87rem',
  '880': '88rem',
  '890': '89rem',
  '900': '90rem',
  '910': '91rem',
  '920': '92rem',
  '930': '93rem',
  '940': '94rem',
  '950': '95rem',
  '960': '96rem',
  '970': '97rem',
  '980': '98rem',
  '990': '99rem',
  '1000': '100rem',
  '1020': '102rem',
  '1040': '104rem',
  '1060': '106rem',
  '1080': '108rem',
  '1100': '110rem',
  '1120': '112rem',
  '1140': '114rem',
  '1160': '116rem',
  '1180': '118rem',
  '1200': '120rem',
  '1220': '122rem',
  '1240': '124rem',
  '1260': '126rem',
  '1280': '128rem',
  '1300': '130rem',
  '1320': '132rem',
  '1340': '134rem',
  '1360': '136rem',
  '1380': '138rem',
  '1400': '140rem',
  '1420': '142rem',
  '1440': '144rem',
  '1460': '146rem',
  '1480': '148rem',
  '1500': '150rem',
  '1520': '152rem',
  '1540': '154rem',
  '1560': '156rem',
  '1580': '158rem',
  '1600': '160rem',
  '1620': '162rem',
  '1640': '164rem',
  '1660': '166rem',
  '1680': '168rem',
  '1700': '170rem',
  '1720': '172rem',
  '1740': '174rem',
  '1760': '176rem',
  '1780': '178rem',
  '1800': '180rem',
  '1820': '182rem',
  '1840': '184rem',
  '1860': '186rem',
  '1880': '188rem',
  '1900': '190rem',
  '1920': '192rem',
  '1940': '194rem',
  '1960': '196rem',
  '1980': '198rem',
  '2000': '200rem'
});